import React, { useState } from 'react';
import InSchedulelayout from './InSchedulelayout';

function Generator() {
  const [formData, setFormData] = useState({
    // Basic Information
    facilityName: '',
    facilityAddress: '',
    testType: 'Monthly',
    inspectorCertification: '',
    testDate: '',
    inspectorName: '',
    
    // Generator Information
    manufacturer: '',
    model: '',
    serialNumber: '',
    fuelType: 'Diesel',
    ratedPower: '',
    ratedVoltage: '',
    ratedFrequency: '',
    
    // Test Parameters
    loadPercentage: '',
    runTime: '',
    oilPressure: '',
    coolantTemp: '',
    batteryVoltage: '',
    fuelLevel: '',
    
    // Test Results
    voltageOutput: '',
    frequencyOutput: '',
    issuesFound: '',
    correctiveActions: '',
    nextTestDate: '',
    
    // Additional Details
    ambientTemperature: '',
    humidity: '',
    weatherConditions: 'Clear',

  // Visual Inspection
  generalCondition: "Good",
  corrosionPresent: false,
  leaksPresent: false,
  mountingSecure: false,
  ventilationAdequate: false,

  // Fuel System
  fuelLevel: "",
  fuelQuality: "Good",
  fuelFilterCondition: "Good",
  fuelPumpOperation: "Normal",
  fuelLinesSecure: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Test documentation submitted successfully!');
  };

  const handleClear = () => {
    setFormData({
      facilityName: '',
      facilityAddress: '',
      testType: 'Monthly',
      inspectorCertification: '',
      testDate: '',
      inspectorName: '',
      manufacturer: '',
      model: '',
      serialNumber: '',
      fuelType: 'Diesel',
      ratedPower: '',
      ratedVoltage: '',
      ratedFrequency: '',
      loadPercentage: '',
      runTime: '',
      oilPressure: '',
      coolantTemp: '',
      batteryVoltage: '',
      fuelLevel: '',
      voltageOutput: '',
      frequencyOutput: '',
      issuesFound: '',
      correctiveActions: '',
      nextTestDate: '',
      ambientTemperature: '',
      humidity: '',
      weatherConditions: 'Clear'
    });
  };

  const [compliance, setCompliance] = useState({
    nfpa: true,
    localCode: true,
    manufacturer: true,
    notes: "",
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCompliance((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleNotesChange = (e) => {
    setCompliance((prev) => ({
      ...prev,
      notes: e.target.value,
    }));
  };


  return (
    <InSchedulelayout>
      <div className="bg-white h-full rounded-md flex flex-col overflow-y-auto p-4">
        {/* Header */}
        <div className="bg-white rounded-lg p-6 mb-4 shadow-sm border border-gray-200">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Emergency Power System Test (NFPA 110)</h1>
          <p className="text-gray-600">Comprehensive generator testing and maintenance documentation</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Basic Information Section */}
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Basic Information</h2>
            <p className="text-gray-600 mb-4">Facility and inspector information for the emergency power test</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Facility Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="facilityName"
                  value={formData.facilityName}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter facility name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Test Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="testDate"
                  value={formData.testDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Facility Address
                </label>
                <textarea
                  name="facilityAddress"
                  value={formData.facilityAddress}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter complete facility address"
                  rows={3}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Inspector Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="inspectorName"
                  value={formData.inspectorName}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter inspector name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Test Type
                </label>
                <select
                  name="testType"
                  value={formData.testType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                >
                  <option value="Monthly">Monthly Test</option>
                  <option value="Quarterly">Quarterly Test</option>
                  <option value="Annual">Annual Test</option>
                  <option value="Emergency">Emergency Test</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Inspector Certification
                </label>
                <input
                  type="text"
                  name="inspectorCertification"
                  value={formData.inspectorCertification}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter certification details"
                />
              </div>
            </div>

            <div className="bg-red-50 rounded-xl shadow-inner p-6 border border-red-200 mt-5">
  <h2 className="text-lg font-semibold text-gray-800">
    NFPA 110 Maintenance Schedule Reference
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
    <div>
      <h3 className="font-semibold text-gray-700 mb-2">Weekly Tasks</h3>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Run generator in auto mode check</li>
        <li>Verify fuel/oil/coolant levels</li>
        <li>Check for alarms and faults</li>
      </ul>
    </div>

    <div>
      <h3 className="font-semibold text-gray-700 mb-2">Monthly Tasks</h3>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Exercise generator under load (per OEM)</li>
        <li>Inspect battery and charging system</li>
        <li>Inspect air intake and exhaust</li>
      </ul>
    </div>
  </div>
</div>
          </div>

          {/* Generator Information Section */}
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Generator Information</h2>
            <p className="text-gray-600 mb-4">Technical specifications and details of the emergency generator</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Manufacturer <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="manufacturer"
                  value={formData.manufacturer}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="e.g., Caterpillar, Cummins, Kohler"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Model <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter model"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Serial Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="serialNumber"
                  value={formData.serialNumber}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter serial number"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Fuel Type
                </label>
                <select
                  name="fuelType"
                  value={formData.fuelType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                >
                  <option value="Diesel">Diesel</option>
                  <option value="Gasoline">Gasoline</option>
                  <option value="Propane">Propane</option>
                  <option value="Natural Gas">Natural Gas</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rated Power (kW) <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="ratedPower"
                  value={formData.ratedPower}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter rated power in kW"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rated Voltage (V)
                </label>
                <input
                  type="number"
                  name="ratedVoltage"
                  value={formData.ratedVoltage}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter rated voltage"
                />
              </div>

               <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Installation Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="installationDate"
                  value={formData.installationDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                />
              </div>

               <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Last Maintenance Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="lastMaintenanceDate"
                  value={formData.lastMaintenanceDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                />
              </div>

            </div>
          </div>


{/* Visual Inspection Section */}
<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Visual Inspection</h2>
  <p className="text-gray-600">General condition and visual assessment</p>

  <div className="mt-3 space-y-4 flex gap-5">
    {/* General Condition */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        General Condition
      </label>
      <div className="flex gap-4">
        {["Excellent", "Good", "Fair", "Poor"].map((condition) => (
          <label key={condition} className="flex items-center gap-2">
            <input
              type="radio"
              name="generalCondition"
              value={condition}
              checked={formData.generalCondition === condition}
              onChange={handleChange}
            />
            {condition}
          </label>
        ))}
      </div>
    </div>

    {/* Checkboxes */}
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="leaksPresent"
        checked={formData.leaksPresent}
        onChange={(e) =>
          setFormData({ ...formData, leaksPresent: e.target.checked })
        }
      />
      <span>Leaks Present</span>
    </div>
  </div>

<div className=' flex gap-5 mt-4'>
<div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="corrosionPresent"
        checked={formData.corrosionPresent}
        onChange={(e) =>
          setFormData({ ...formData, leaksPresent: e.target.checked })
        }
      />
      <span>Corrosion Present</span>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="ventilationAdequate"
        checked={formData.ventilationAdequate}
        onChange={(e) =>
          setFormData({ ...formData, ventilationAdequate: e.target.checked })
        }
      />
      <span>Ventilation Adequate</span>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="corrosionPresent"
        checked={formData.corrosionPresent}
        onChange={(e) =>
          setFormData({ ...formData, corrosionPresent: e.target.checked })
        }
      />
      <span>Mounting Secure</span>
    </div>
</div>
  
</div>

{/* Fuel System Section */}
<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Fuel System</h2>
  <p className="text-gray-600">
    Fuel level, quality, and system components
  </p>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Level (%)
      </label>
      <input
        type="number"
        name="fuelLevel"
        value={formData.fuelLevel}
        onChange={handleChange}
        placeholder="Enter fuel level"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Quality
      </label>
      <select
        name="fuelQuality"
        value={formData.fuelQuality}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Filter Condition
      </label>
      <select
        name="fuelFilterCondition"
        value={formData.fuelFilterCondition}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Pump Operation
      </label>
      <select
        name="fuelPumpOperation"
        value={formData.fuelPumpOperation}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Normal">Normal</option>
        <option value="Irregular">Irregular</option>
        <option value="Failing">Failing</option>
      </select>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="fuelLinesSecure"
        checked={formData.fuelLinesSecure}
        onChange={(e) =>
          setFormData({ ...formData, fuelLinesSecure: e.target.checked })
        }
      />
      <span>Fuel Lines Secure</span>
    </div>
  </div>
</div>

<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Electrical System</h2>
  <p className="text-gray-600">
    Battery status, wiring, and component conditions
  </p>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Battery Voltage (V)
      </label>
      <input
        type="number"
        name="batteryVoltage"
        value={formData.batteryVoltage}
        onChange={handleChange}
        placeholder="Enter battery voltage"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Battery Condition
      </label>
      <select
        name="batteryCondition"
        value={formData.batteryCondition}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
       Charging System
      </label>
      <select
        name="chargingSystem"
        value={formData.chargingSystem}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
       Control Panel
      </label>
      <select
        name="controlPanel"
        value={formData.controlPanel}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Normal">Normal</option>
        <option value="Irregular">Irregular</option>
        <option value="Failing">Failing</option>
      </select>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="batteryTerminal"
        checked={formData.batteryTerminal}
        onChange={(e) =>
          setFormData({ ...formData, batteryTerminal: e.target.checked })
        }
      />
      <span>Battery Terminals Clean</span>
    </div>
  </div>
</div>

<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Startup Test</h2>
  <p className="text-gray-600">Manual and automatic start test results</p>

  <div className="mt-3 space-y-4  gap-5">
    {/* General Condition */}
  <div className=' flex gap-5 mt-4'>
<div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="manualStartSuccessful"
        checked={formData.manualStartSuccessful}
        onChange={(e) =>
          setFormData({ ...formData, manualStartSuccessful: e.target.checked })
        }
      />
      <span>Manual Start Successful</span>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="automaticStartSuccessful"
        checked={formData.automaticStartSuccessful}
        onChange={(e) =>
          setFormData({ ...formData, automaticStartSuccessful: e.target.checked })
        }
      />
      <span>Automatic Start Successful</span>
    </div>

  </div>

  <div className=' flex gap-5 mt-4'>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Startup Time (seconds)
      </label>
      <input
        type="number"
        name="startupTime"
        value={formData.startupTime}
        onChange={handleChange}
        placeholder="Enter startup time"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

     <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Initial Voltage (V)
      </label>
      <input
        type="number"
        name="initialVoltage"
        value={formData.initialVoltage}
        onChange={handleChange}
        placeholder="Enter initial voltage"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

     <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Initial Frequency (Hz)
      </label>
      <input
        type="number"
        name="initialFrequency"
        value={formData.initialFrequency}
        onChange={handleChange}
        placeholder="Enter initial frequency"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

     <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Oil Pressure (PSI)
      </label>
      <input
        type="number"
        name="oilPressure"
        value={formData.oilPressure}
        onChange={handleChange}
        placeholder="Enter oil pressure"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>
  </div>

  
</div>
</div>

<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Load Test</h2>
  <p className="text-gray-600">Generator performance under load conditions</p>

   <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
       Load Applied (%)
      </label>
      <input
        type="number"
        name="loadApplied"
        value={formData.loadApplied}
        onChange={handleChange}
        placeholder="Enter load applied"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Test Duration (minutes)
      </label>
      <input
        type="number"
        name="testDuration"
        value={formData.testDuration}
        onChange={handleChange}
        placeholder="Enter test duration"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Loaded Voltage (V)
      </label>
      <input
        type="number"
        name="loadedVoltage"
        value={formData.loadedVoltage}
        onChange={handleChange}
        placeholder="Enter loaded voltage"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Loaded Frequency (Hz)
      </label>
      <input
        type="number"
        name="loadedFrequency"
        value={formData.loadedFrequency}
        onChange={handleChange}
        placeholder="Enter loaded frequency"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Oil Pressure (PSI)
      </label>
      <input
        type="number"
        name="oilPressure"
        value={formData.oilPressure}
        onChange={handleChange}
        placeholder="Enter oil pressure"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Coolant Temp (°F)
      </label>
      <input
        type="number"
        name="coolantTemp"
        value={formData.coolantTemp}
        onChange={handleChange}
        placeholder="Enter coolant temperature"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="performanceSatisfactory"
        checked={formData.performanceSatisfactory}
        onChange={(e) =>
          setFormData({ ...formData, performanceSatisfactory: e.target.checked })
        }
      />
      <span>Performance Satisfactory</span>
    </div>
  </div>
</div>

{/* Maintenance Performed Section */}
<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Maintenance Performed</h2>
  <p className="text-gray-600">
    Record all maintenance activities performed during this inspection
  </p>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
    {[
      "Oil Changed",
      "Oil Filter Replaced",
      "Fuel Filter Replaced",
      "Air Filter Replaced",
      "Spark Plugs Replaced",
      "Battery Maintenance",
      "Coolant System Flushed",
      "Belts Inspected",
      "Belts Replaced",
    ].map((item) => (
      <label key={item} className="flex items-center gap-2">
        <input
          type="checkbox"
          name={item.replace(/\s+/g, "").toLowerCase()}
          checked={formData[item.replace(/\s+/g, "").toLowerCase()] || false}
          onChange={(e) =>
            setFormData({
              ...formData,
              [item.replace(/\s+/g, "").toLowerCase()]: e.target.checked,
            })
          }
        />
        {item}
      </label>
    ))}
  </div>

  <div className="mt-4">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Other Maintenance Performed
    </label>
    <textarea
      name="otherMaintenance"
      value={formData.otherMaintenance || ""}
      onChange={handleChange}
      placeholder="Describe any additional maintenance activities..."
      rows={3}
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
    />
  </div>
</div>

 <div className="bg-white rounded-xl shadow-sm border p-6 flex items-center justify-between">
      {/* Left Side Content */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900">
          Deficiencies and Recommendations
        </h2>
        <p className="text-sm text-gray-500">
          Document any issues found and recommended corrective actions
        </p>
      </div>

      {/* Right Side Button */}
      <button className="px-4 py-2 text-sm font-medium text-red-600 border border-red-600 rounded-lg hover:bg-red-600 hover:text-white transition">
        Add Deficiency
      </button>
    </div>

     <div className="bg-white rounded-xl shadow-sm border p-6 space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Test Summary</h2>
        <p className="text-sm text-gray-500">
          Overall test results and conclusions
        </p>
      </div>

      {/* Overall Result, Next Test Due, Next Maintenance Due */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Overall Result
          </label>
          <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500">
            <option>Pass</option>
            <option>Fail</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Next Test Due
          </label>
          <input
            type="date"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Next Maintenance Due
          </label>
          <input
            type="date"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
          />
        </div>
      </div>

      {/* Recommendations */}
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Recommendations
        </label>
        <textarea
          rows="3"
          placeholder="Enter any additional recommendations..."
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
        />
      </div>

      <hr />

      {/* Inspector + Facility Representative */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Inspector Signature */}
        <div>
          <h3 className="font-semibold text-gray-900 text-sm mb-2">
            Inspector Signature
          </h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700">
                Digital Signature
              </label>
              <input
                type="text"
                placeholder="Type full name for digital signature"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">Date</label>
              <input
                type="date"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
          </div>
        </div>

        {/* Facility Representative */}
        <div>
          <h3 className="font-semibold text-gray-900 text-sm mb-2">
            Facility Representative
          </h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700">
                Representative Name
              </label>
              <input
                type="text"
                placeholder="Enter facility representative name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">
                Digital Signature
              </label>
              <input
                type="text"
                placeholder="Type full name for digital signature"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
          </div>
        </div>
        <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700">Date</label>
              <input
                type="date"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
          </div>
      </div>
    </div>

<div className="bg-white rounded-xl shadow-sm border p-6 space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Test Summary</h2>
        <p className="text-sm text-gray-500">
          Overall test results and conclusions
        </p>
      </div>
           <div className="flex flex-wrap gap-6">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="nfpa"
              checked={compliance.nfpa}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-red-600"
            />
            NFPA 110 Compliant
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="localCode"
              checked={compliance.localCode}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-red-600"
            />
            Local Code Compliant
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="manufacturer"
              checked={compliance.manufacturer}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-red-600"
            />
            Manufacturer Guidelines Followed
          </label>
        </div>

        <div>
          <textarea
            placeholder="Enter any compliance-related notes or exceptions..."
            value={compliance.notes}
            onChange={handleNotesChange}
            className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-red-400"
            rows="4"
          />
        </div>

        <div className="flex justify-end gap-4">
          <button
            type="button"
            className="px-4 py-2 border rounded-lg hover:bg-gray-100"
            onClick={() => alert("Going back to start")}
          >
            Back to Start
          </button>
          <button
            type="submit"
            className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Submit Test Report
          </button>
        </div>
        </div>
        </form>
      </div>
    </InSchedulelayout>
  );
}

export default Generator;